<script setup>
import videojs from 'video.js'
import {defineProps, onMounted, reactive} from "vue";

const props = defineProps({
    content: Object
});

const state = reactive({
    player: null,
    duration: null
});

onMounted(() => {
    state.player = videojs("video")

    state.player.on('loadedmetadata', () => {
        state.duration = Math.round(state.player.duration());
    })
})
</script>

<template>
    <div class="md:w-4/5 h-[70vh] w-full flex justify-center items-center overflow-hidden">
        <video
            id="video"
            class="video-js vjs-fill"
            controls
            preload="auto"
            data-setup='{ "preload": "auto"}'
            :poster="content.value.thumbnail">
            <source type="video/mp4" v-bind:src="props.content.value"/>
            <p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that<a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p>
        </video>
    </div>
</template>

<style scoped>
@import '~video.js/dist/video-js.css';

.center-play-button .vjs-big-play-button {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
    line-height: 100px;
    font-size: 60px;
}

</style>
